import ObservableClass, * as ObservableModule from './../node_modules/ol/Observable.js';

// Create a wrapper class
const Observable = ObservableClass;

// Copy all named exports as static methods
for (const key in ObservableModule) {
    if (key !== "default") {
        Observable[key] = ObservableModule[key];
    }
}

export default Observable;
